import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';

import {
  actions as communitiesJoinRequests,
  paginatedActions as paginatedcommunitiesJoinRequests,
} from '../../../redux/communities/communitiesJoinRequests';
import {
  sendingCommunitiesJoinRequestsSelector,
  selectNewNotifications,
} from '../../../redux/communities/selectors/communitiesJoinRequests';
import { actions as removeNotificationsCounters } from '../../../redux/communities/removeNotificationsCounters';
import { activitiesActions } from '../../../redux/communities/activities';
import {
  selectActivitiesActiveTab,
  selectActivitiesList,
  selectActivityCounterByType,
  selectIsActivitiesNotEmpty,
} from '../../../redux/communities/selectors/activitiesSelector';
import { ACTIVITY_TYPES } from '../../../constants';
import { FONT_FAMILY } from '../../../constants/styles';
import styles from '../index.styl';

const tabStyles = {
  root: {
    fontFamily: FONT_FAMILY.primary,
    textTransform: 'initial',
    paddingLeft: 0,
    fontWeight: 400,
  },
  label: {
    fontSize: 14,
    lineHeight: 1.5,
    paddingLeft: 0,
  },
};

const { JOIN_REQUESTS, NOTIFICATIONS, MEMBER_INVITATIONS } = ACTIVITY_TYPES;

const mapDispatchToProps = {
  communitiesJoinReq: communitiesJoinRequests.send,
  loadNextRequests: paginatedcommunitiesJoinRequests.loadNextRequests,
  removeNotifications: removeNotificationsCounters.send,
  pageLeave: communitiesJoinRequests.pageLeave,
  changeTab: activitiesActions.changeTab,
};
const mapStateToProps = state => ({
  tab: selectActivitiesActiveTab(state),
  list: selectActivitiesList(state),
  hasNotifications: selectIsActivitiesNotEmpty(state),

  sendingJoinRequests: sendingCommunitiesJoinRequestsSelector(state),
  joinReqCounter: selectActivityCounterByType(JOIN_REQUESTS)(state),
  invitesCounter: selectActivityCounterByType(MEMBER_INVITATIONS)(state),
  notifyCounter: selectActivityCounterByType(NOTIFICATIONS)(state),
  newNotifications: selectNewNotifications(state),
});

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(tabStyles),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Communities/Activities/enhance.js